import { render } from "./PlanA.vue?vue&type=template&id=36328a46"
import script from "./PlanA.vue?vue&type=script&lang=js"
export * from "./PlanA.vue?vue&type=script&lang=js"

import "./PlanA.vue?vue&type=style&index=0&id=36328a46&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__